import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import retargetEvents from 'react-shadow-dom-retarget-events';

import CompendiumLoader from '@/components/CompendiumLoader';
import FittingHardware from '@/components/FittingHardware';

import { Store } from 'redux';
import { initializeStore } from '@/redux/store';
import { initialState, reducer } from '@/redux/fitting-hardware';
import { TargetGroup } from '@/types/fitting-hardware';

class HomeTariffFittingHardware extends HTMLElement {
  mountPoint: Element;

  serviceUrl: string;

  tariffOfferName: string;

  targetGroup: TargetGroup;

  shopContext: string;

  store: Store;

  selectedConnectionType: string | null;

  isFmsTariff: string;

  isHeroOfferHardware: string;

  static get observedAttributes() {
    return ['serviceurl', 'shopcontext', 'targetgroup', 'tariffoffername', 'selectedconnectiontype', 'isfmstariff', 'isheroofferhardware'];
  }

  connectedCallback() {
    this.store = initializeStore(initialState, reducer);

    this.mountPoint = document.createElement('span');
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(this.mountPoint);
    retargetEvents(shadowRoot);

    try {
      this.serviceUrl = this.getRequiredAttribute('serviceUrl');
      this.tariffOfferName = this.getRequiredAttribute('tariffOfferName');
      this.shopContext = this.getRequiredAttribute('shopContext');
      this.targetGroup = (TargetGroup as any)[this.getRequiredAttribute('targetGroup').toUpperCase()];
      this.selectedConnectionType = this.getAttribute('selectedConnectionType');
      this.isFmsTariff = this.getRequiredAttribute('isFmsTariff');
      this.isHeroOfferHardware =  this.getRequiredAttribute('isHeroOfferHardware');
    } catch (error) {
      console.log(error.message);
    }

    this.render();
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    switch (name) {
      case 'serviceurl':
        this.serviceUrl = newValue;
        break;
      case 'tariffoffername':
        this.tariffOfferName = newValue;
        break;
      case 'shopcontext':
        this.shopContext = newValue;
        break;
      case 'targetgroup':
        this.targetGroup = (TargetGroup as any)[newValue.toUpperCase()];
        break;
      case 'selectedconnectiontype':
        this.selectedConnectionType = newValue;
        break;
      case 'isfmstariff':
        this.isFmsTariff = newValue;
        break;
      case 'isheroofferhardware':
        this.isHeroOfferHardware = newValue;
        break;
      default: break;
    }

    this.render();
  }

  getRequiredAttribute(qualifiedName: string) : string {
    const value = this.getAttribute(qualifiedName);
    if (!value) {
      throw new Error(`HomeTariffFittingHardware: Missing parameters ${qualifiedName} = ${value}`);
    }

    return value;
  }

  render() {
    if (this.mountPoint
      && this.serviceUrl
      && this.tariffOfferName
      && this.targetGroup
      && this.shopContext
      && this.isFmsTariff
      && this.isHeroOfferHardware
    ) {
      ReactDOM.render(
        <Provider store={this.store}>
          <CompendiumLoader serviceUrl={this.serviceUrl} />
          <FittingHardware
            serviceUrl={this.serviceUrl}
            tariffOfferName={this.tariffOfferName}
            targetGroup={this.targetGroup}
            shopContext={this.shopContext}
            dispatchEvent={(event: CustomEvent) => this.dispatchEvent(event)}
            selectedConnectionType={this.selectedConnectionType}
            isFmsTariff={this.isHeroOfferHardware !="true" ?  this.isFmsTariff =="true" : false }
          />
        </Provider>,
        this.mountPoint,
      );
    }
  }
}

if (window && window.customElements !== undefined) {
  window.customElements.define('home-tariff-fitting-hardware', HomeTariffFittingHardware)
}

